
export const IS_FNSHO_MODAL_IS_OPEN = 'classDetail/IS_FNSHO_MODAL_IS_OPEN';
